const DESIGN_WIDTH = 750;
const REM_DIVISOR = 10;

function setRootFontSize() {
  const viewportWidth =
    document.documentElement.clientWidth || window.innerWidth;
  const boundedWidth = Math.min(viewportWidth, DESIGN_WIDTH);
  const fontSize = boundedWidth / REM_DIVISOR;
  document.documentElement.style.fontSize = `${fontSize}px`;
}

export function initRem() {
  setRootFontSize();
  window.addEventListener("resize", setRootFontSize);
  window.addEventListener("orientationchange", setRootFontSize);
}
